import { TFunction } from "i18next";
import { Country, CurrencyByCountry, Language } from "../../../../i18n";
import { getIntlNumberFormat } from "../../../../components/utils";
import { Alternative } from "../../../../components/interactions/InputTypes";

export function getMaxValueOpts(
  t: TFunction,
  language: Language,
  country: Country
): Alternative<number>[] {
  // 0-99, 100-499, 500-999, 1000-2499, 2500-4999, 5000+
  if (country === Country.FINLAND) {
    return [
      {
        value: "" as unknown as number,
        text: t("Cost of most expensive item?"),
        disabled: true,
      },
      {
        disabled: false,
        value: 50,
        text: `${getIntlNumberFormat(language, 0)} - ${getIntlNumberFormat(
          language,
          100
        )} ${CurrencyByCountry[country]}`,
      },
      {
        disabled: false,
        value: 300,
        text: `${getIntlNumberFormat(language, 101)} - ${getIntlNumberFormat(
          language,
          500
        )} ${CurrencyByCountry[country]}`,
      },
      {
        disabled: false,
        value: 750,
        text: `${getIntlNumberFormat(language, 501)} - ${getIntlNumberFormat(
          language,
          1000
        )} ${CurrencyByCountry[country]}`,
      },
      {
        disabled: false,
        value: 1750,
        text: `${getIntlNumberFormat(language, 1001)} - ${getIntlNumberFormat(
          language,
          2500
        )} ${CurrencyByCountry[country]}`,
      },
      {
        disabled: false,
        value: 3750,
        text: `${getIntlNumberFormat(language, 2501)} - ${getIntlNumberFormat(
          language,
          5000
        )} ${CurrencyByCountry[country]}`,
      },
      {
        disabled: false,
        value: 7500,
        text: `${getIntlNumberFormat(language, 5001)} - ${getIntlNumberFormat(
          language,
          10000
        )} ${CurrencyByCountry[country]}`,
      },
      {
        disabled: false,
        value: 70000,
        text: `${getIntlNumberFormat(language, 10001)} - ${getIntlNumberFormat(
          language,
          100000
        )} ${CurrencyByCountry[country]}`,
      },
    ];
  }

  return [
    {
      value: "" as unknown as number,
      text: t("Cost of most expensive item?"),
      disabled: true,
    },
    {
      disabled: false,
      value: 500,
      text: `${getIntlNumberFormat(language, 0)} - ${getIntlNumberFormat(
        language,
        1000
      )} ${CurrencyByCountry[country]}`,
    },
    {
      disabled: false,
      value: 3000,
      text: `${getIntlNumberFormat(language, 1001)} - ${getIntlNumberFormat(
        language,
        5000
      )} ${CurrencyByCountry[country]}`,
    },
    {
      disabled: false,
      value: 7500,
      text: `${getIntlNumberFormat(language, 5001)} - ${getIntlNumberFormat(
        language,
        10000
      )} ${CurrencyByCountry[country]}`,
    },
    {
      disabled: false,
      value: 17500,
      text: `${getIntlNumberFormat(language, 10001)} - ${getIntlNumberFormat(
        language,
        25000
      )} ${CurrencyByCountry[country]}`,
    },
    {
      disabled: false,
      value: 37500,
      text: `${getIntlNumberFormat(language, 25001)} - ${getIntlNumberFormat(
        language,
        50000
      )} ${CurrencyByCountry[country]}`,
    },
    {
      disabled: false,
      value: 75000,
      text: `${getIntlNumberFormat(language, 50001)} - ${getIntlNumberFormat(
        language,
        100000
      )} ${CurrencyByCountry[country]}`,
    },
    {
      disabled: false,
      value: 700000,
      text: `${getIntlNumberFormat(language, 100001)} - ${getIntlNumberFormat(
        language,
        1000000
      )} ${CurrencyByCountry[country]}`,
    },
  ];
}

export function getTurnoverOpts(
  t: TFunction,
  language: Language,
  country: Country
) {
  if (country === Country.FINLAND) {
    return [
      {
        value: "" as unknown as number,
        text: t("Select annual turnover"),
        disabled: true,
      },
      {
        value: 25_000,
        text: `${getIntlNumberFormat(language, 0)} - ${getIntlNumberFormat(
          language,
          50_000
        )} ${CurrencyByCountry[country]}`,
      },
      {
        value: 125_000,
        text: `${getIntlNumberFormat(language, 50_001)} - ${getIntlNumberFormat(
          language,
          200_000
        )} ${CurrencyByCountry[country]}`,
      },
      {
        value: 350_000,
        text: `${getIntlNumberFormat(
          language,
          200_001
        )} - ${getIntlNumberFormat(language, 500_000)} ${
          CurrencyByCountry[country]
        }`,
      },
      {
        value: 1_250_000,
        text: `${getIntlNumberFormat(
          language,
          500_001
        )} - ${getIntlNumberFormat(language, 2_000_000)} ${
          CurrencyByCountry[country]
        }`,
      },
      {
        value: 3_500_000,
        text: `${getIntlNumberFormat(
          language,
          2_000_001
        )} - ${getIntlNumberFormat(language, 5_000_000)} ${
          CurrencyByCountry[country]
        }`,
      },
      {
        value: 7_500_000,
        text: `${getIntlNumberFormat(
          language,
          5_000_001
        )} - ${getIntlNumberFormat(language, 10_000_000)} ${
          CurrencyByCountry[country]
        }`,
      },
    ];
  }

  return [
    {
      value: "" as unknown as number,
      text: t("Select annual turnover"),
      disabled: true,
    },
    {
      value: 250_000,
      text: `${getIntlNumberFormat(language, 0)} - ${getIntlNumberFormat(
        language,
        500_000
      )} ${CurrencyByCountry[country]}`,
    },
    {
      value: 1_250_000,
      text: `${getIntlNumberFormat(language, 500_001)} - ${getIntlNumberFormat(
        language,
        2_000_000
      )} ${CurrencyByCountry[country]}`,
    },
    {
      value: 3_500_000,
      text: `${getIntlNumberFormat(
        language,
        2_000_001
      )} - ${getIntlNumberFormat(language, 5_000_000)} ${
        CurrencyByCountry[country]
      }`,
    },
    {
      value: 12_500_000,
      text: `${getIntlNumberFormat(
        language,
        5_000_001
      )} - ${getIntlNumberFormat(language, 20_000_000)} ${
        CurrencyByCountry[country]
      }`,
    },
    {
      value: 35_000_000,
      text: `${getIntlNumberFormat(
        language,
        20_000_001
      )} - ${getIntlNumberFormat(language, 50_000_000)} ${
        CurrencyByCountry[country]
      }`,
    },
    {
      value: 75_000_000,
      text: `${getIntlNumberFormat(
        language,
        50_000_001
      )} - ${getIntlNumberFormat(language, 100_000_000)} ${
        CurrencyByCountry[country]
      }`,
    },
  ];
}
